export const hasFeature = (enabledFeatures, feature) => enabledFeatures && enabledFeatures.length > 0 ? enabledFeatures.includes(feature) : true;